import { render, staticRenderFns } from "./UiChecklist.vue?vue&type=template&id=a4ab1fd0&scoped=true"
import script from "./UiChecklist.vue?vue&type=script&lang=js"
export * from "./UiChecklist.vue?vue&type=script&lang=js"
import style0 from "./UiChecklist.vue?vue&type=style&index=0&id=a4ab1fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ab1fd0",
  null
  
)

export default component.exports